// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"DocFormModal_fullWidth__puCQ7"};